import { Component, OnInit } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { FieldConfig } from "../../../interfaces/field.interface";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "@ionic/angular";
import { CommonModule } from "@angular/common";
@Component({
  selector: "app-text-area",
  template: `
    <ion-item [formGroup]="group" lines="none">
      <div class="alinhamento-div">
        <label position="stacked" class="custom-label">
          {{ field.label }}
          <span
            *ngIf="field.validations && field.validations[0] && field.validations[0].name == 'required'"
            class="danger"
            >*</span
          >
        </label>
        <ion-textarea
          arial-label=""
          placeholder="{{ field.label ? (field.label | translate) : '' }}"
          rows="3"
          [formControlName]="field.name"
        >
        </ion-textarea>
      </div>
    </ion-item>

    <div class="validation-errors">
      <ng-container *ngFor="let validation of field.validations">
        <div
          class="error-message"
          *ngIf="
            group.get(field.name)?.hasError(validation.name) &&
            (group.get(field.name)?.dirty || group.get(field.name)?.touched)
          "
        >
          {{ "Campo Obrigatório" | translate }}
        </div>
      </ng-container>
    </div>
  `,
  styles: [
    `
      .alinhamento-div {
        display: flex;
        flex-direction: column;
        width: 100%;
      }

      ion-textarea {
        --padding-top: 0 !important;
        --padding-bottom: 0 !important;
        font-size: 14px;
        max-width: 100%;
        max-height: 70px;
        padding: 0;
        color: #787486;
        label .label-text-wrapper {
          font-size: 1.3rem;
          color: black;
        }
      }

      ion-item {
        --inner-border-width: 0;
        padding-top: 5px;
        margin: 0 20px;
      }

      .error-message {
        padding: 0px !important;
        font-size: 12px !important;
      }

      .validation-errors {
        margin-left: 35px;
      }

      .custom-label {
        font-size: 15px;
        font-weight: 500;
      }
    `,
  ],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule, ReactiveFormsModule],
})
export class TextAreaComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  mask: any = {};
  constructor() {}

  ngOnInit() {}
}
